/**
 * Tracking Code
 * The functions within this file are set up to allow ease of tracking events and page views across an Application
 * By default, a Google Analytics implemtation is included below
 * If you want/need a different type, you will need to write it yourself
 * 		Note: You will likely need to write an event normalizer since the functions expect GA specific property names
 *
 */

/* eslint-disable indent */
import { SHOW_TRACKING } from "utils/common";

/**
 * TrackEvent()
 * @param {object} event Valid Tracking Event
 *  event.eventCategory:  The Interaction Event
 *  event.eventAction:    The Actions the User took to invoke this event
 *  event.eventLabel:     The Label for this event
 *  event.eventValue:     Unique value of this event (eg. uid)
 *  event.transport:      Transport method for the event
 *  event.nonInteraction: Did this event happen without the user's input?
 *
 * More info - https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 */
export function TrackEvent(event){
	if(!event.hitType) { event.hitType = "event"; }

	if(SHOW_TRACKING) {
		console.groupCollapsed("%cTracking Event:%c", "color: #40b658; font-weight:bold;", "color:#000; font-weight:normal;");
			console.log(event);
		console.groupEnd();
	}
}

/**
 * TrackPage()
 * @param {object} page Valid Pageview Tracking
 *  page.title: The title of the current page view to track
 *  page.location: The location of the page to track
 *  page.page: The path of the URL to track
 *
 * More info: - https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
 */
export function TrackPage(page){
	if(!page.hitType) { page.hitType = "pageview"; }

	if(SHOW_TRACKING) {
		console.groupCollapsed("%cTracking Page:%c", "color:#d11560; font-weight:bold;", "color:#000; font-weight:normal;");
			console.log(page);
		console.groupEnd();
	}
}

/**
 * TrackTime()
 * @param {object} time Valid Timing Tracking Object
 *  time.timingCategory: The Type of timing we want to track (JS Loading, AJAX Loading, IFRAME Loading)
 *  time.timingVar: Identiy of the thing we are timing
 *  time.timingValue: How long did the request take (in miliseconds)
 *  time.timingLabel: Optional Label for this timing event
 *
 * More info: - https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings
 */
export function TrackTime(time){
	if(time.hitType) { time.hitType = "timing"; }

	if(SHOW_TRACKING) {
		console.groupCollapsed("%cTracking Timing:%c", "color:#1771B9; font-weight:bold;", "color:#000; font-weight:normal;");
			console.log(time);
		console.groupEnd();
	}
}

const Tracking = {
	TrackEvent,
	TrackPage,
	TrackTime,
};

export default Tracking;
/* eslint-enable indent */
